import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService } from '../../services/notification.service';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from '../../services/authentication.service';
import { NavigationService } from '../../services/navigation.service';

type LinkedinEnvironment = typeof environment & {
  linkedinClientId?: string;
  linkedinRedirectUri?: string;
  linkedinState?: string;
};

const linkedinEnvironment = environment as LinkedinEnvironment;

@Component({
    selector: 'fp-linkedin-login-button',
    templateUrl: './linkedin-login-button.component.html',
    styleUrl: './linkedin-login-button.component.scss',
    standalone: false
})
export class LinkedinLoginButtonComponent {
  @Input() signup: boolean = false;
  @Input() lang: string = 'en';
  @Input() deeplinkId?: string;

  constructor(
    private notificationService: NotificationService,
    private translate: TranslateService
  ) {}

  private resolveDeeplinkId(): string | null {
    if (this.deeplinkId) {
      return this.deeplinkId;
    }
    const params = new URLSearchParams(window.location.search);
    return params.get('uuid') || params.get('deeplink') || null;
  }

  redirectToLinkedin(): void {
    if (!linkedinEnvironment.linkedinClientId) {
      this.notificationService.openSnackBar('error', this.translate.instant('AUTH.LINKEDIN_LOGIN.UNAVAILABLE'));
      return;
    }

    sessionStorage.setItem('linkedinSignup', String(this.signup));
    const state = crypto.randomUUID();
    sessionStorage.setItem('linkedinState', state);
    const deeplinkId = this.resolveDeeplinkId();
    if (deeplinkId) {
      sessionStorage.setItem('authDeeplink', deeplinkId);
    } else {
      sessionStorage.removeItem('authDeeplink');
    }
    window.location.assign(this.buildLinkedinAuthorizationUrl(state));
  }

  private buildLinkedinAuthorizationUrl(state: string): string {
    const params = new URLSearchParams({
      response_type: 'code',
      client_id: linkedinEnvironment.linkedinClientId,
      redirect_uri: linkedinEnvironment.linkedinRedirectUri || `${window.location.origin}/auth/linkedin/callback`,
      scope: 'openid profile email',
      state: state,
    });

    return `https://www.linkedin.com/oauth/v2/authorization?${params.toString()}`;
  }
}
